import { useEffect } from 'react';
import { useParams, Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite';

import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';

import CollaboratorsList from 'components/CollaboratorsList';
import AssistantOnly from 'components/AssistantOnly';
import { LoreDecorator } from "components/Lore";
import { capitalize } from 'utils/misc';


export const CollabsListTitle = ({ status }: { status: string }) => {

    if (status == "snoozed") {
        return (
            <Stack>
                <Typography level="title-lg">Snoozed Collabs</Typography>
                <Typography level="body-xs">We'll let you know if someone replies to one of these.</Typography>
            </Stack>
        );
    }
    else if (status == "archived") {
        return (
            <Stack>
                <Typography level="title-lg">Archive</Typography>
                <Typography level="body-xs">Closed Requests. Collabs you've left.</Typography>
            </Stack>
        );
    }
    else if (status == "active") {
        return (
            <Stack>
                <Typography
                    level="title-lg"
                    endDecorator={<LoreDecorator slug="assistant/lists/your-collaborations" />}
                >Your Collaborations</Typography>
                <Typography level="body-xs">These are your open items</Typography>
            </Stack>
        );
    }
    return null;
};


const CollabsListRoute = observer(() => {
    const { status = "active" } = useParams<{ status: string }>();
    useEffect(() => {
        document.title = capitalize(status) + ' Collabs';
    }, [status]);
    return (
        <Stack spacing={2}>
            <CollaboratorsList status={status} paged={false} />
        </Stack>
    );
});


export const CollabsListRouteContainer = observer(() => {
    const { status = "active" } = useParams<{ status: string }>();

    // ICs don't see the available collabs list
    const allowIC = status != 'available';

    return (
        <AssistantOnly allowIC={allowIC}>
            <Outlet />
        </AssistantOnly>
    );
});


export default CollabsListRoute;
